/* =============================================================
   FRIDO MONO — theme.js (no dependencies)
   Header, drawers, predictive search, Shopify AJAX cart,
   slideshow, product gallery / variants / sticky bar, hotspots.
   ============================================================= */
(function () {
  'use strict';
  var M = window.MONO || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.remove('no-js');
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = M.moneyFormat || 'Rs.{{amount_no_decimals}}';
    function num(n, d, t, dec) { var x = (n / 100).toFixed(d).split('.'); return x[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (x[1] ? dec + x[1] : ''); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return num(cents, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return num(cents, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return num(cents, 0, '.', ',');
      return num(cents, 2, ',', '.');
    }).replace(/<[^>]*>/g, '');
  }

  /* ---------- toast ---------- */
  var toastEl, tt;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('show'); clearTimeout(tt); tt = setTimeout(function () { toastEl.classList.remove('show'); }, 2400);
  }

  /* ---------- overlays ---------- */
  var scrim = $('[data-scrim]'), open = null, back = null;
  var F = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';
  function trapKey(e) {
    if (!open || e.key !== 'Tab') return;
    var f = $$(F, open).filter(function (n) { return n.offsetParent !== null; }); if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  }
  function openPanel(id, focusSel) {
    var p = document.getElementById(id); if (!p) return;
    if (open && open !== p) closePanel(true);
    back = document.activeElement; open = p;
    p.classList.add('is-open'); p.removeAttribute('aria-hidden');
    if (id !== 'menu' && scrim) scrim.classList.add('is-open');
    document.body.classList.add('is-locked');
    $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    setTimeout(function () { var t = (focusSel && $(focusSel, p)) || $(F, p); if (t) t.focus(); }, 60);
  }
  function closePanel(silent) {
    if (!open) return;
    var p = open; open = null;
    p.classList.remove('is-open'); p.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    $$('[aria-controls="' + p.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (!silent && back) back.focus();
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanel(); trapKey(e); });
  if (scrim) scrim.addEventListener('click', function () { closePanel(); });
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); var t = o.getAttribute('data-open'); openPanel(t, t === 'search' ? '#q' : null); return; }
    if (e.target.closest('.burger')) { openPanel('menu'); return; }
    if (e.target.closest('[data-close]')) { closePanel(); return; }
    if (e.target.closest('#menu a')) closePanel(true);
  });

  /* ---------- header scroll + announcement ---------- */
  var header = $('#header');
  if (header) { var sc = function () { header.classList.toggle('is-scrolled', window.scrollY > 6); }; sc(); window.addEventListener('scroll', sc, { passive: true }); }
  var ann = $('.announce'), msgs = $$('.announce__msg');
  if (ann && msgs.length > 1 && !RM) {
    var ai = 0, at = null, speed = (+ann.getAttribute('data-speed') || 4) * 1000;
    var tick = function () { msgs[ai].classList.remove('is-active'); msgs[ai].setAttribute('aria-hidden', 'true'); ai = (ai + 1) % msgs.length; msgs[ai].classList.add('is-active'); msgs[ai].removeAttribute('aria-hidden'); };
    var go = function () { at = setInterval(tick, speed); };
    ann.addEventListener('mouseenter', function () { clearInterval(at); }); ann.addEventListener('mouseleave', go); go();
  }

  /* ---------- predictive search ---------- */
  var q = $('#q'), res = $('[data-results]');
  if (q && res) {
    var st;
    var run = function () {
      var term = q.value.trim(); if (!term) { res.innerHTML = ''; return; }
      fetch((M.routes.predictive || '/search/suggest') + '.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
          res.innerHTML = ps.map(function (p) {
            return '<a class="hit" href="' + p.url + '"><span class="thumb">' + (p.image ? '<img src="' + p.image + '&width=120" alt="">' : '') + '</span><span><strong>' + esc(p.title) + '</strong><span>' + money(Math.round(parseFloat(p.price) * 100)) + '</span></span></a>';
          }).join('') + '<a class="hit" href="' + M.routes.search + '?q=' + encodeURIComponent(term) + '&type=product"><span><strong>' + (ps.length ? 'See all results' : 'Nothing here. Try something else.') + '</strong><span>Search the store</span></span></a>';
        }).catch(function () {});
    };
    q.addEventListener('input', function () { clearTimeout(st); st = setTimeout(run, 180); });
    $$('[data-q]').forEach(function (b) { b.addEventListener('click', function () { q.value = b.getAttribute('data-q'); run(); q.focus(); }); });
  }

  /* ---------- accordions ---------- */
  $$('.acc__btn').forEach(function (b) {
    var panel = b.parentElement.nextElementSibling; if (!panel) return;
    if (!b.querySelector('.acc__ico')) b.insertAdjacentHTML('beforeend', '<span class="acc__ico" aria-hidden="true"></span>');
    if (b.getAttribute('aria-expanded') === 'true') panel.classList.add('open');
    b.addEventListener('click', function () { var o = b.getAttribute('aria-expanded') === 'true'; b.setAttribute('aria-expanded', String(!o)); panel.classList.toggle('open', !o); });
  });

  /* ---------- reveal ---------- */
  var rv = $$('[data-reveal]');
  if ('IntersectionObserver' in window && !RM) {
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    rv.forEach(function (n) { io.observe(n); });
  } else rv.forEach(function (n) { n.classList.add('in'); });

  /* ---------- drag-scroll tracks ---------- */
  $$('[data-drag]').forEach(function (t) {
    var down = false, sx = 0, sl = 0, moved = false;
    t.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = t.scrollLeft; });
    window.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 4) { moved = true; t.classList.add('drag'); } t.scrollLeft = sl - dx; });
    window.addEventListener('pointerup', function () { down = false; t.classList.remove('drag'); });
    t.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    $$('[data-scroll-prev="' + t.id + '"]').forEach(function (b) { b.addEventListener('click', function () { t.scrollBy({ left: -t.clientWidth * .8, behavior: 'smooth' }); }); });
    $$('[data-scroll-next="' + t.id + '"]').forEach(function (b) { b.addEventListener('click', function () { t.scrollBy({ left: t.clientWidth * .8, behavior: 'smooth' }); }); });
  });

  /* ---------- slideshow ---------- */
  $$('[data-slides]').forEach(function (root) {
    var slides = $$('.slide', root), dots = $$('.dot', root); if (slides.length < 2) return;
    var i = 0, timer = null, dur = (+root.getAttribute('data-speed') || 7) * 1000;
    var playing = root.getAttribute('data-autoplay') !== 'false' && !RM;
    root.style.setProperty('--dur', dur + 'ms');
    var show = function (n, user) {
      slides[i].classList.remove('is-active'); slides[i].inert = true;
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active'); slides[i].inert = false;
      dots.forEach(function (d, k) { d.setAttribute('aria-current', 'false'); if (k === i) { void d.offsetWidth; d.setAttribute('aria-current', 'true'); } });
      if (user) { playing = false; root.classList.add('paused'); }
      clearTimeout(timer); if (playing) timer = setTimeout(function () { show(i + 1); }, dur);
    };
    slides.forEach(function (s, k) { if (k) s.inert = true; });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k, true); }); });
    var p = $('[data-prev]', root), n = $('[data-next]', root);
    if (p) p.addEventListener('click', function () { show(i - 1, true); });
    if (n) n.addEventListener('click', function () { show(i + 1, true); });
    var x0 = 0; root.addEventListener('pointerdown', function (e) { x0 = e.clientX; });
    root.addEventListener('pointerup', function (e) { if (e.pointerType === 'mouse') return; var dx = e.clientX - x0; if (Math.abs(dx) > 45) show(i + (dx < 0 ? 1 : -1), true); });
    if (!playing) root.classList.add('paused');
    requestAnimationFrame(function () { show(0); });
  });

  /* =============================================================
     CART (Shopify AJAX API)
     ============================================================= */
  var cart = { items: [], item_count: 0, total_price: 0 };
  var R = M.routes || {};
  function api(url, body) {
    return fetch(url, { method: body ? 'POST' : 'GET', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body ? JSON.stringify(body) : undefined })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function refresh() { return api(R.cartJs).then(function (c) { cart = c; render(); return c; }); }
  function add(id, qty) {
    return api(R.cartAdd, { items: [{ id: Number(id), quantity: Math.max(1, parseInt(qty, 10) || 1) }] }).then(refresh)
      .then(function () { $$('[data-count]').forEach(function (n) { n.classList.add('pop'); setTimeout(function () { n.classList.remove('pop'); }, 300); }); })
      .catch(function (e) { toast((e && e.description) || 'Could not add to bag'); throw e; });
  }
  function change(key, qty) { return api(R.cartChange, { id: key, quantity: Math.max(0, qty) }).then(function (c) { cart = c; render(); }); }
  function removeHandle(h) {
    var up = {}; cart.items.forEach(function (i) { if (i.handle === h) up[i.key] = 0; });
    return Object.keys(up).length ? api(R.cartUpdate, { updates: up }).then(function (c) { cart = c; }) : Promise.resolve();
  }
  var I = {
    minus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/></svg>',
    plus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12h14"/></svg>'
  };
  function lineHtml(l) {
    var img = l.image ? '<img src="' + l.image + (l.image.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="">' : '';
    return '<div class="line"><a class="line__img" href="' + l.url + '">' + img + '</a><div><a class="line__name" href="' + l.url + '">' + esc(l.product_title) + '</a>' +
      (l.product_has_only_default_variant ? '' : '<p class="line__meta">' + esc(l.variant_title) + '</p>') +
      '<div class="line__row"><div class="qty"><button type="button" data-chg="' + l.key + '" data-to="' + (l.quantity - 1) + '" aria-label="Decrease">' + I.minus + '</button><output>' + l.quantity + '</output><button type="button" data-chg="' + l.key + '" data-to="' + (l.quantity + 1) + '" aria-label="Increase">' + I.plus + '</button></div>' +
      '<button class="rm" type="button" data-chg="' + l.key + '" data-to="0">Remove</button></div></div><p class="line__price">' + money(l.final_line_price) + '</p></div>';
  }
  function shipBar() {
    var t = M.freeShipping; if (!t) return '';
    var s = cart.total_price / 100, left = Math.max(0, t - s), pct = Math.min(100, Math.round(s / t * 100));
    return '<div class="ship"><span>' + (left > 0 ? (M.strings.shipAway || 'You’re [amount] away from free shipping').replace('[amount]', '<strong>' + money(left * 100) + '</strong>') : (M.strings.shipDone || 'Free shipping unlocked.')) + '</span><div class="ship__track"><div class="ship__fill" style="width:' + pct + '%"></div></div></div>';
  }
  function upsellHtml() {
    var u = M.upsell; if (!u || !u.id || !u.available) return '';
    if (cart.items.some(function (l) { return l.handle === u.handle; })) return '';
    return '<div class="upsell-mini"><span class="thumb">' + (u.image ? '<img src="' + u.image + '" alt="">' : '') + '</span><span><strong style="font-weight:500">' + esc(u.title) + '</strong><br><span class="muted">' + money(u.price) + '</span></span><button class="btn btn--sm" type="button" data-add="' + u.id + '">Add</button></div>';
  }
  function emptyHtml() { return '<div class="empty"><p class="t-l">' + esc(M.strings.empty || 'Your bag is empty.') + '</p><a class="btn" href="' + R.shop + '">' + esc(M.strings.emptyBtn || 'Start shopping') + '</a></div>'; }
  function render() {
    $$('[data-count]').forEach(function (n) { n.textContent = cart.item_count; n.classList.toggle('has', cart.item_count > 0); });
    $$('[data-count-text]').forEach(function (n) { n.textContent = cart.item_count ? '(' + cart.item_count + ')' : ''; });
    var body = $('[data-cart-body]'), foot = $('[data-cart-foot]');
    if (body) {
      if (!cart.items.length) { body.innerHTML = emptyHtml() + upsellHtml(); foot.hidden = true; }
      else {
        body.innerHTML = shipBar() + cart.items.map(lineHtml).join('') + upsellHtml(); foot.hidden = false;
        foot.innerHTML = '<div class="sum"><span>Subtotal</span><span>' + money(cart.total_price) + '</span></div><p class="t-s">Shipping and discounts at checkout.</p><button class="btn btn--block" type="button" data-checkout>Checkout</button>';
      }
    }
    var page = $('[data-cart-page]');
    if (page) {
      page.innerHTML = !cart.items.length ? '<div class="wrap" style="padding-bottom:var(--sp)">' + emptyHtml() + '</div>' :
        '<div class="wrap cart-page"><div>' + shipBar() + cart.items.map(lineHtml).join('') + '</div><aside class="summary"><div class="row"><span class="muted">Items</span><span>' + cart.item_count + '</span></div><div class="row total"><span>Subtotal</span><span>' + money(cart.total_price) + '</span></div><button class="btn btn--block" type="button" data-checkout>Checkout</button><a class="btn btn--ghost btn--block" href="' + R.shop + '">Keep shopping</a></aside></div>';
    }
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-add]');
    if (a) {
      e.preventDefault(); if (a.classList.contains('is-busy')) return;
      var id = a.getAttribute('data-add'); var vf = a.getAttribute('data-vfrom'); if (vf && $(vf)) id = $(vf).value;
      var qf = a.getAttribute('data-qfrom'), qty = qf && $(qf) ? $(qf).value : 1;
      a.classList.add('is-busy');
      var pre = a.hasAttribute('data-swap') ? removeHandle(a.getAttribute('data-swap')) : Promise.resolve();
      pre.then(function () { return add(id, qty); }).then(function () {
        a.classList.remove('is-busy');
        if (a.hasAttribute('data-now')) { location.href = R.checkout; return; }
        openPanel('cart');
      }).catch(function () { a.classList.remove('is-busy'); });
      return;
    }
    var c = e.target.closest('[data-chg]');
    if (c) { change(c.getAttribute('data-chg'), +c.getAttribute('data-to')); return; }
    if (e.target.closest('[data-checkout]')) location.href = R.checkout;
  });
  refresh().catch(function () {});

  /* =============================================================
     PRODUCT PAGE
     ============================================================= */
  var gal = $('[data-gallery]');
  if (gal) {
    var vp = $('.gallery__vp', gal), slides = $$('.gallery__slide', vp), thumbs = $$('[data-thumb]', gal), cnt = $('[data-count-g]', gal), cur = 0;
    var go = function (k) { vp.scrollTo({ left: vp.clientWidth * k, behavior: RM ? 'auto' : 'smooth' }); };
    var sync = function () {
      var k = Math.round(vp.scrollLeft / Math.max(1, vp.clientWidth)); cur = k;
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', String(j === k)); });
      if (cnt) cnt.textContent = slides.length > 1 ? (k + 1) + ' / ' + slides.length : '';
    };
    sync();
    var gs; vp.addEventListener('scroll', function () { clearTimeout(gs); gs = setTimeout(sync, 60); }, { passive: true });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.getAttribute('data-thumb')); }); });
    vp.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') go(Math.min(slides.length - 1, cur + 1)); if (e.key === 'ArrowLeft') go(Math.max(0, cur - 1)); });
    document.addEventListener('variant:change', function (e) { slides.forEach(function (s, k) { if (e.detail.mid && s.getAttribute('data-media-id') === e.detail.mid) go(k); }); });
    /* zoom */
    var zooms = $$('[data-zoom]', vp);
    if (zooms.length) {
      var lb = document.createElement('div'); lb.className = 'lightbox'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', 'Image zoom');
      lb.innerHTML = '<div class="lightbox__head"><span data-lbc></span><button class="x-btn" type="button" data-lbx aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div><div class="lightbox__stage"><img alt=""></div><div class="lightbox__nav"><button class="circle" type="button" data-lbp aria-label="Previous">‹</button><button class="circle" type="button" data-lbn aria-label="Next">›</button></div>';
      document.body.appendChild(lb);
      var li = 0, lbShow = function (k) { li = (k + zooms.length) % zooms.length; $('img', lb).src = zooms[li].getAttribute('data-zoom'); $('[data-lbc]', lb).textContent = (li + 1) + ' / ' + zooms.length; };
      var lbClose = function () { lb.classList.remove('open'); document.body.classList.remove('is-locked'); };
      zooms.forEach(function (z, k) { z.addEventListener('click', function () { lbShow(k); lb.classList.add('open'); document.body.classList.add('is-locked'); $('[data-lbx]', lb).focus(); }); });
      $('[data-lbx]', lb).addEventListener('click', lbClose);
      $('[data-lbp]', lb).addEventListener('click', function () { lbShow(li - 1); });
      $('[data-lbn]', lb).addEventListener('click', function () { lbShow(li + 1); });
      lb.addEventListener('keydown', function (e) { if (e.key === 'Escape') lbClose(); if (e.key === 'ArrowLeft') lbShow(li - 1); if (e.key === 'ArrowRight') lbShow(li + 1); });
    }
  }
  /* variants */
  var pills = $$('[data-pills] [data-vid]');
  pills.forEach(function (b) {
    b.addEventListener('click', function () {
      pills.forEach(function (x) { x.setAttribute('aria-checked', String(x === b)); });
      var vid = $('#vid'); if (vid) vid.value = b.getAttribute('data-vid');
      var vn = $('[data-vname]'); if (vn) vn.textContent = b.getAttribute('data-title');
      $$('[data-price]').forEach(function (n) { n.textContent = b.getAttribute('data-p'); });
      $$('[data-compare]').forEach(function (n) { var c = b.getAttribute('data-c'); n.textContent = c; n.hidden = !c; });
      var ok = b.getAttribute('data-available') === 'true';
      $$('[data-atc]').forEach(function (x) { x.disabled = !ok; x.textContent = ok ? (x.getAttribute('data-label') || 'Add to bag') : 'Sold out'; });
      try { var u = new URL(location.href); u.searchParams.set('variant', b.getAttribute('data-vid')); history.replaceState({}, '', u); } catch (err) {}
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { mid: b.getAttribute('data-mid') } }));
    });
  });
  /* quantity */
  $$('[data-qty]').forEach(function (w) {
    var inp = $('input', w), clamp = function (v) { v = parseInt(v, 10); return isNaN(v) ? 1 : Math.max(1, Math.min(20, v)); };
    $$('[data-step]', w).forEach(function (b) { b.addEventListener('click', function () { inp.value = clamp(+inp.value + (+b.getAttribute('data-step'))); }); });
    inp.addEventListener('change', function () { inp.value = clamp(inp.value); });
  });
  /* sticky bar */
  var atcMain = $('[data-buy] [data-atc]'), sticky = $('[data-sticky]');
  if (atcMain && sticky && 'IntersectionObserver' in window) {
    var vis = true, foot = false, ft = $('.footer');
    var upd = function () { var s = !vis && !foot; sticky.classList.toggle('show', s); sticky.setAttribute('aria-hidden', String(!s)); sticky.inert = !s; document.body.classList.toggle('has-sticky', s); };
    new IntersectionObserver(function (e) { vis = e[0].isIntersecting; upd(); }).observe(atcMain);
    if (ft) new IntersectionObserver(function (e) { foot = e[0].isIntersecting; upd(); }).observe(ft);
  }
  /* hotspots */
  $$('[data-spots]').forEach(function (root) {
    var spots = $$('.spot', root), list = $$('[data-spot]', root.parentElement);
    var set = function (k) {
      spots.forEach(function (s, j) { s.classList.toggle('is-open', j === k); $('.spot__btn', s).setAttribute('aria-expanded', String(j === k)); });
      list.forEach(function (b) { b.setAttribute('aria-pressed', String(+b.getAttribute('data-spot') === k)); });
    };
    spots.forEach(function (s, k) { $('.spot__btn', s).addEventListener('click', function (e) { e.stopPropagation(); set(s.classList.contains('is-open') ? -1 : k); }); });
    list.forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); set(+b.getAttribute('data-spot')); }); });
    document.addEventListener('click', function () { set(-1); });
  });

  window.MonoCart = { refresh: refresh, add: add, open: function () { openPanel('cart'); } };
})();
